var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 459,
    height: 307,
    viewBox: "0 0 459 307",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 315.196,
    y: 213.056,
    width: 45.0309,
    height: 92.9437,
    rx: 3.51536,
    fill: "#00ADB5",
    stroke: "black",
    strokeWidth: 1.64486,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 197.395,
    y: 239.895,
    width: 45.0309,
    height: 66.1053,
    rx: 3.51536,
    fill: "#EEEEEE",
    stroke: "black",
    strokeWidth: 1.64486,
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 406.338,
    y: 110.026,
    width: 45.0309,
    height: 195.974,
    rx: 3.51536,
    fill: "#00ADB5",
    stroke: "black",
    strokeWidth: 1.64486,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M209.426 190.848C213.525 183.418 213.283 181.295 212.348 173.817C211.834 169.698 211.637 165.674 210.595 161.622C208.732 154.377 208.127 144.62 213.961 138.786C225.44 127.307 246.817 143.632 240.344 158.196C237.881 163.739 233.624 167.843 230.549 173.071C229.315 175.168 228.625 177.44 227.022 179.4C225.484 181.279 223.575 183.617 223.575 185.95C223.575 187.921 224.163 190.476 222.769 192.219C220.843 194.625 221.528 193.388 218.677 193.388C216.718 193.388 213.828 191.83 212.248 190.566C211.119 189.663 210.514 192.274 210.514 189.76C210.514 187.601 211.209 189.397 209.789 189.397",
    stroke: "#2F7578",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M218.496 197.741C214.616 196.584 203.877 194.001 206.362 197.197C209.361 201.053 210.644 199.12 214.324 199.938C216.206 200.356 218.04 206.165 215.956 206.287C212.98 206.462 211.006 202.458 207.975 202.458C205.216 202.458 205.413 206.089 207.068 207.375C209.253 209.075 211.765 207.248 213.235 209.895C215.559 214.077 209.212 213.397 207.41 212.414C205.595 211.424 203.869 209.879 202.533 208.988",
    stroke: "#2F7578",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M209.426 189.669C209.475 189.985 209.527 192.118 210.378 192.118C210.837 192.118 211.048 191.84 211.467 192.072C211.959 192.346 212.421 192.991 212.893 193.367C213.308 193.7 214.541 193.659 214.777 194.073C215.164 194.75 215.949 195.12 216.682 195.202C217.632 195.307 217.983 195.784 218.995 195.559C219.304 195.491 219.335 195.292 219.625 195.292C220.072 195.292 220.265 195.506 220.602 195.131C220.976 194.716 221.586 194.522 221.766 193.892C222.011 193.035 222.908 192.584 221.58 193.116",
    stroke: "#2F7578",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M226.931 153.752C225.308 153.76 223.967 153.865 223.414 155.586C223.037 156.757 223.031 157.907 223.031 159.123C223.031 160.305 223.756 161.256 223.756 162.368C223.756 163.839 222.58 163.598 221.585 164.046C220.644 164.469 219.963 164.823 219.453 165.769C218.948 166.707 219.33 168.519 219.398 169.538C219.456 170.415 219.873 172.279 219.267 173.02C218.937 173.423 217.136 174.045 218.314 173.161",
    stroke: "#2F7578",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M240.627 170.168C241.926 171.032 243.25 171.755 244.703 172.3C245.312 172.528 246.114 172.936 245.978 171.982",
    stroke: "#2F7578",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M245.343 157.652C247.646 158.206 249.933 158.831 252.216 159.446C252.596 159.548 251.724 158.588 251.692 158.559",
    stroke: "#2F7578",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M245.978 145.77C248.363 145.424 250.74 144.994 253.113 144.571C254.205 144.377 254.668 144.52 254.05 143.594",
    stroke: "#2F7578",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M233.098 133.163C234.983 132.832 236.616 132.513 238.319 131.661C239.116 131.263 239.883 130.784 240.717 130.462C241.708 130.08 241.729 130.196 240.627 129.535",
    stroke: "#2F7578",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M216.682 125C216.407 126.925 216.498 128.078 217.276 129.822C217.696 130.763 218.051 131.951 218.259 132.966C218.33 133.316 218.37 133.515 218.607 133.778C218.695 133.876 218.371 132.708 218.314 132.528",
    stroke: "#2F7578",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M202.805 132.709C203.407 134.714 204.265 136.637 204.78 138.645C205.04 139.661 204.878 139.723 204.437 138.696",
    stroke: "#2F7578",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M197 147.131C199.061 148.914 200.751 151.128 202.351 153.318C202.552 153.593 202.784 153.69 203.006 153.913C203.512 154.419 202.639 153.277 202.533 153.117",
    stroke: "#2F7578",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.72367 66.274C9.49114 54.0548 15.8881 37.6725 32.6123 42.1538C40.5593 44.2832 46.7344 56.1295 46.2487 63.6615C45.8457 69.9093 47.5811 77.8003 41.1332 81.6902C36.0686 84.7456 29.6683 84.3116 25.6745 79.5815C14.3328 66.1489 35.2904 56.7371 45.6826 58.7922C59.8673 61.5972 76.3042 96.9365 63.9494 108.098C53.3564 117.668 46.3867 102.982 53.7858 94.2718C64.1942 82.0187 73.7683 81.63 85.8718 94.7353C95.3223 104.968 92.4801 123.028 84.8549 132.529C83.2712 134.503 77.3438 148.315 75.9126 146.93C61.7901 133.266 86.81 113.134 100.713 115.996C116.687 119.285 132.813 122.795 143.371 135.439C149.049 142.238 159.529 166.563 157.515 157.936C154.995 147.141 152.576 132.327 157.05 121.575C158.382 118.376 162.386 108.057 159.005 118.073C155.523 128.389 152.216 137.394 150.799 147.637C150.484 149.916 153.446 153.15 154.457 155.083C155.313 156.721 148.649 154.617 147.853 154.534C140.977 153.82 134.693 156.468 128.802 159.759C123.544 162.697 117.526 168.21 113.561 166.25",
    stroke: "#00ADB5",
    strokeOpacity: 0.2,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M306.241 102.397C314.201 98.2806 322.317 92.8978 329.434 87.3939C333.242 84.4488 337.34 81.9234 341.025 78.8749C341.544 78.4453 342.823 76.4192 343.595 77.083C344.812 78.1306 345.992 79.95 346.736 81.3658C348.899 85.4785 351.883 89.6058 354.939 93.0694C357.364 95.8168 359.333 98.1371 361.176 101.33C362.184 103.076 364.688 105.459 364.508 107.4C364.008 112.813 358.95 117.826 355.479 121.367C350.379 126.57 345.382 131.8 339.316 135.799C335.554 138.28 331.313 139.59 327.465 141.811C323.92 143.857 324.211 143.583 320.836 140.609C317.511 137.68 315.454 134.502 313.198 130.595C312.024 128.562 309.925 126.806 308.292 125.125C307.055 123.853 306.606 121.68 305.939 120.079C305.24 118.399 305.302 113.582 303.768 112.579C302.264 111.595 300.519 109.434 300.942 107.497C301.286 105.916 314.454 96.6472 303.457 106.994",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M302.051 109.941C305.047 111.396 307.962 113.485 310.928 114.85C311.914 115.304 313.597 115.219 314.392 115.84C316.544 117.52 322.761 116.5 325.401 116.742C328.382 117.016 336.549 121.104 337.644 116.079C339.702 106.634 342.006 97.2313 344.056 87.8241C344.444 86.0467 343.921 84.2921 344.274 82.6692C345.351 77.7287 340.611 80.8463 339.008 81.7717",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M397.97 38.4646C401.674 29.7306 400.157 22.1201 400.157 13.0687C400.157 11.3079 399.838 5.94438 401.688 4.98443C404.606 3.47051 407.333 2.46032 410.776 2.46032C413.065 2.46032 415.365 2.52626 417.653 2.46032C419.941 2.39436 422.158 1.4635 424.421 1.18636C428.63 0.6707 433.009 1.38876 437.166 1.38876C440.467 1.38876 443.881 1.81738 447.056 1.81738C447.62 1.81738 449.918 2.08614 450.288 2.41269C451.421 3.41211 451.096 5.01487 451.989 5.8893",
    stroke: "#2F7578",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M451.771 6.66333C451.915 9.24074 451.969 12.8576 453.03 15.376C453.717 17.008 453.169 19.1801 453.308 20.9183C453.575 24.255 453.078 27.5072 453.078 30.7443C453.078 35.0867 453.296 39.3736 453.296 43.6923C453.296 47.3991 449.674 46.7785 446.81 46.2577C444.335 45.8078 441.015 46.7099 438.436 46.7417C433.46 46.8032 428.462 47.1774 423.479 47.1774C419.317 47.1774 416.227 45.9688 412.394 44.5152C410.348 43.7389 409.111 43.9101 406.913 43.9101C404.831 43.9101 403.119 43.5846 401.032 44.2368C399.811 44.6184 397.624 44.289 396.929 43.0388C396.097 41.5398 397.752 40.8897 397.752 39.6627C397.752 38.6324 397.623 35.6861 397.97 38.4647",
    stroke: "#2F7578",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M422.801 12.3265C422.801 12.3265 423.673 12.7621 424.544 13.6334C425.415 14.2869 427.249 13.9602 428.791 13.9602C429.603 13.9602 430.46 13.3276 431.187 13.0042C432.661 12.3491 431.782 13.5813 431.429 14.2869C431.039 15.068 431.485 16.5202 432.192 17.0096C433.358 17.8171 434.512 17.1201 435.653 16.5498C436.126 16.313 435.996 16.2032 436.143 16.5256C436.342 16.9628 436.306 17.5973 436.306 18.0745C436.306 19.1604 436.235 20.9645 435.653 21.9105C434.887 23.1549 434.113 23.9604 432.882 24.8753C431.665 25.779 430.058 27.356 428.441 27.356C425.28 27.356 421.926 26.6673 420.345 23.5926C419.675 22.2892 418.445 21.2221 418.445 19.7323C418.445 18.4893 418.034 16.9998 418.445 15.8116C418.944 14.3713 420.188 13.0042 419.752 13.0042C419.974 13.0677 421.93 11.8909 422.801 12.3265Z",
    stroke: "#2F7578",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M426.395 11.5641C427.621 11.1105 430.42 10.1603 431.079 8.67801C431.588 7.53247 429.905 7.31665 429.009 7.31665C427.923 7.31665 426.636 8.81777 426.347 9.7671C426.186 10.295 426.034 10.8353 425.875 11.3705C425.799 11.6285 425.901 11.8155 425.954 12.0542C425.994 12.236 427.656 11.3635 427.593 11.1136",
    stroke: "#2F7578",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M447.961 36.0733L400.179 37.1227C395.077 37.2348 391 41.4025 391 46.5052C391 51.6883 395.202 55.89 400.385 55.89H448.178C453.651 55.89 458.088 51.4534 458.088 45.9805C458.088 40.4224 453.517 35.9512 447.961 36.0733Z",
    fill: "#2F7578",
    fillOpacity: 0.5,
    stroke: "#2F7578",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M410.742 36.8597C411.465 37.9814 412.09 39.3275 412.92 40.3651C413.338 40.887 413.271 40.7809 414.08 40.4811C415.431 39.9807 416.962 40.3393 418.372 40.3393C419.609 40.3393 421.048 39.6933 422.251 40.0172C423.644 40.3923 425.287 39.6761 426.658 39.6434C428.311 39.6041 429.886 39.7594 431.53 39.7594C432.521 39.7594 433.487 39.1795 434.404 39.1795C434.936 39.1795 436.453 39.6012 436.492 38.6253C436.511 38.1499 436.724 37.6881 436.724 37.2077C436.724 36.5578 436.335 36.8392 435.68 36.5117",
    stroke: "#2F7578",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactChart);
export default __webpack_public_path__ + "static/media/contact_chart.29d419a7063875a06a031dbb0a533540.svg";
export { ForwardRef as ReactComponent };